import { Component, OnInit, NgZone, TemplateRef } from '@angular/core';
import { environment } from '../../../environments/environment';
import { LoginResponse, LoginOptions, FacebookService, InitParams } from '@jemys89/ngx-facebook';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Foto } from '../../clases/foto';
import { Usuario } from '../../clases/usuario';
import { BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import { UserService } from '../../service/user.service';
import { AlertService } from '../../service/alert.service';
import { DatosCompartidosService } from '../../service/datos-compartidos.service';
import { Router } from '@angular/router';
import * as NavidateUserAgent from 'src/app/util/detect-navigator/navigator-user-agent';
import { HttpClient } from '@angular/common/http';



@Component({
  selector: 'app-iniciar-sesion',
  templateUrl: './iniciar-sesion.component.html',
  styleUrls: ['./iniciar-sesion.component.css']
})
export class IniciarSesionComponent implements OnInit {
  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private _datosCompartidos: DatosCompartidosService,
    private alertService: AlertService,
    private ngZone: NgZone,
    private fb: FacebookService,
    private modalService: BsModalService,
    private _userService: UserService,
    private _http: HttpClient
  ) {

    if (environment.INICIO_FB) {
      let initParams: InitParams = {
        appId: environment.APPIDFB,
        xfbml: true,
        version: 'v3.1'
      };

      fb.init(initParams);
    }

  }

  //Form
  loginForm: FormGroup;
  loginFormSeniorTaxi: FormGroup;
  recuperarCuentaForm: FormGroup;
  contraseniaForm: FormGroup;

  state = 'in';
  submitted: boolean = false;

  registro: boolean = false;
  sesion: boolean = true;
  //registrarComo: boolean = false;

  claveOculta: boolean = true;
  clave: boolean = false;
  showPassword: boolean = false;
  error: boolean = false;



  showBtnConectarFB: number = 1;

  //Modal
  modalRef: BsModalRef;
  modalRecuperar: BsModalRef;
  template: TemplateRef<any>;
  modalCuenta: BsModalRef;

  //Obj
  public user: Usuario = new Usuario();
  datosFB: any;

  //FB
  options: LoginOptions = {
    scope: 'email, public_profile',
    return_scopes: true,
    enable_profile_selector: true
  };

  inicioFb = environment.INICIO_FB;
  registroUsuario = environment.REGISTRO_USUARIO;
  olvideContrasenia=environment.OLVIDE_CONTRASENIA;
  cod_cliente : string = environment.CODCLIENTE;
  picture: Foto;
  btnDisabledCFB: boolean = false;
  iconChkFB: boolean = false;


//  olvideContrasenia: boolean = false;

  //Pais
  pais: any;
  paisCode: string = 'PE';

  //S
  disabledBtnIngresar : boolean = false
  disabledRecuperarContrasenia: boolean = false;

  //lblPersonalizado
  btnRegistrarse: string = '';
  btnRecuperarContrasenia: string = '';

  //IMG
  logo = {
    url: environment.LOGO_INICIO_SESION.URL,
    alt: environment.LOGO_INICIO_SESION.ALT,
    url_img_1: environment.IMAGEN_SESION_1.URL,
    alt_img_1: environment.IMAGEN_SESION_1.ALT,
    url_img_2: environment.IMAGEN_SESION_2.URL,
    alt_img_2: environment.IMAGEN_SESION_2.ALT
  }
  flagCliente : boolean
  codcliente : string = environment.CODCLIENTE
  enviar: boolean = false;
  ngOnInit() {
    this.flagCliente = environment.CODCLIENTE  === 'NXVSENIORTAXI' || 'NXVLILIGAS' ? true : false
    this.btnRegistrarse = environment.LABELS_PERSONALIZACION.btnRegistrarse;
    this.btnRecuperarContrasenia = environment.LABELS_PERSONALIZACION.btnRecuperarContraseña;

    this.loginForm = this.formBuilder.group({
      'txtEmail': ['', [Validators.required, Validators.email]],
      'txtClave': ['', Validators.required]
    });
    this.loginFormSeniorTaxi = this.formBuilder.group({
      'CodigoTrabajador': ['', Validators.required],
      'ordenInterno': ['', Validators.required],
      'txtClaveSeniorTaxi': ['', Validators.required]
    });


    this.contraseniaForm = this.formBuilder.group({
      'txtCorreoRecuperar': ['', [Validators.required, Validators.email]]
    });

    this.recuperarCuentaForm = this.formBuilder.group({
      'txtCorreoCuenta': ['', [Validators.required, Validators.email]]
    });

  }

  //Form

  get f() {
    return this.loginForm.controls;
  }
  get fSeniorTaxi() {
    return this.loginFormSeniorTaxi.controls;
  }


  get fContrasenia() {
    return this.contraseniaForm.controls;
  }

  get fCuenta() {
    return this.recuperarCuentaForm.controls;
  }
  ///

  registrarParticular() {
    this._datosCompartidos.datosFb$.next(this.datosFB);
    this.decline();
    this.router.navigate(['registro/2']);
  }

  iniciarSesion() {
    this.enviar = true;
    this.disabledBtnIngresar = true;
    let user
    let country = JSON.parse(localStorage.getItem('country'));
    if(this.codcliente == 'NXVSENIORTAXI'){
      user = {
        OrdenInterno : this.fSeniorTaxi.ordenInterno.value,
        CodigoTrabajador : this.fSeniorTaxi.CodigoTrabajador.value,
        Clave: this.fSeniorTaxi.txtClaveSeniorTaxi.value,
        country: localStorage.getItem('country')
          ? (JSON.parse(localStorage.getItem('country')).country ? JSON.parse(localStorage.getItem('country')).country : JSON.parse(localStorage.getItem('country')))
          : environment.COUNTRY,
        idEquipo:NavidateUserAgent.ipConfig,
        versionSO:NavidateUserAgent.getSOVersion(),
        versionPlataforma:NavidateUserAgent.getNavigatiorVersion(),
        plataforma: "Web " + environment.VERSION
      };
    } else {
      if (this.loginForm.invalid) {
        this.enviar = false
        return;
      }
      user = {
        Email: this.f.txtEmail.value,
        Clave: this.f.txtClave.value,
        idCompany : (environment.VALIDAR_GRUPO_NEGOCIO.ACTIVO)? environment.VALIDAR_GRUPO_NEGOCIO.IDGRUPONEGOCIO:0,
        country: localStorage.getItem('country')
          ? (JSON.parse(localStorage.getItem('country')).country ? JSON.parse(localStorage.getItem('country')).country : JSON.parse(localStorage.getItem('country')))
          : environment.COUNTRY,
        idEquipo:NavidateUserAgent.ipConfig,
        versionSO:NavidateUserAgent.getSOVersion(),
        versionPlataforma:NavidateUserAgent.getNavigatiorVersion(),
        plataforma: "Web " + environment.VERSION
      };
    }

    this._datosCompartidos.guardarUsuario(user).subscribe((error: number) => {
      this.disabledBtnIngresar = false;
      if (error == environment.MENSAJES.LOGIN.CLAVE_INCORRECTA.CODIGO) {
        this.enviar = false
        this.f.txtClave.setValue('');
        this.alertService.error('', environment.MENSAJES.LOGIN.CLAVE_INCORRECTA.DESCRIPCION);

      } else if (error == environment.MENSAJES.LOGIN.USUARIO_INACTIVO.CODIGO) {
        this.enviar = false
        this.alertService.error('', environment.MENSAJES.LOGIN.USUARIO_INACTIVO.DESCRIPCION);

      } else if (error == environment.MENSAJES.LOGIN.NO_EXISTE_USUARIO.CODIGO) {
        this.enviar = false
        this.f.txtClave.setValue('');
        this.alertService.error('', environment.MENSAJES.LOGIN.NO_EXISTE_USUARIO.DESCRIPCION);

      } else if (error == environment.MENSAJES.LOGIN.ERROR.CODIGO) {
        this.enviar = false
        this.alertService.error('', environment.MENSAJES.LOGIN.ERROR.DESCRIPCION);
      }else if (error == environment.MENSAJES.LOGIN.CORREO_SIN_ACCESOS.CODIGO) {
        this.enviar = false
        this.alertService.error('', environment.MENSAJES.LOGIN.CORREO_SIN_ACCESOS.DESCRIPCION);
      }
      else if (error == environment.MENSAJES.LOGIN.USUARIO_NO_RELACIONADO.CODIGO) {
        this.enviar = false
        this.alertService.error('', environment.MENSAJES.LOGIN.USUARIO_NO_RELACIONADO.DESCRIPCION);
      }
      else if (error == environment.MENSAJES.LOGIN.USUARIO_NO_ASIGNADO.CODIGO) {
        this.enviar = false
        this.alertService.error('', environment.MENSAJES.LOGIN.USUARIO_NO_ASIGNADO.DESCRIPCION);
      }
    });
  }

  loginFB(template?: TemplateRef<any>) {

    this.fb.login(this.options)
      .then((res: LoginResponse) => {
        //console.log('Logged in', res);
        this.fb.api('/me', 'get',
          { "fields": "email,first_name,last_name,picture" })
          .then(resp => {

            this.datosFB = resp;
            if (template == undefined) {

              // setTimeout(() => {
              //  // this.showBtnConectarFB = 3;
              this.registrarParticular();
              // }, 2000);
            } else {
              this._datosCompartidos.iniciarSesionFB(resp.email).subscribe((data: any) => {
                this.ngZone.run(() => {
                  if (data == -2) {
                    this.datosFB = resp;
                    this.modalRef = this.modalService.show(template, { class: 'modal-confirm' });
                  } else if (data == -1) {
                    this.alertService.error('', environment.MENSAJES.OCURRIO_PROBLEMA.DESCRIPCION);
                  }
                });

              }, (error => {
                this.showBtnConectarFB = 1;
                this.btnDisabledCFB = false;
                this.alertService.error('', environment.MENSAJES.LOGIN.ERROR.DESCRIPCION)
              }));

            }
          })
          .catch(e => {
            this.showBtnConectarFB = 1;
            this.btnDisabledCFB = false;
            this.alertService.error('', environment.MENSAJES.LOGIN.ERROR.DESCRIPCION);
          });
      })
      .catch(e => {
        this.showBtnConectarFB = 1;
        this.btnDisabledCFB = !this.btnDisabledCFB;
        this.alertService.error('', environment.MENSAJES.LOGIN.ERROR.DESCRIPCION);
      }
      );
  }

  decline(): void {
    this.modalRef.hide();
  }
  cerrarModal(): void {
    this.modalRecuperar.hide();
    this.contraseniaForm.reset();
  }
  recuperarContrasenia() {
    this.disabledRecuperarContrasenia = true;
    if (this.contraseniaForm.invalid) {
      return;
    }
    this.alertService.clear();

    let json = {
      tipo: environment.TIPO_EMAIL.RECUPERAR_CONTRASENIA,
      email: this.contraseniaForm.controls.txtCorreoRecuperar.value
    }

    this._userService.recuperarContrasenia(json).subscribe((data: any) => {
      if (data.idResultado == environment.MENSAJES.LOGIN.RECUPERAR_CONTRASENIA.CODIGO) {
        this.cerrarModal();
        this.contraseniaForm.reset();
        this.alertService.success('', environment.MENSAJES.LOGIN.RECUPERAR_CONTRASENIA.DESCRIPCION);

      } else if (data.idResultado == -2 || data.idResultado == -201) {
        this.cerrarModal();
        this.contraseniaForm.reset();
        this.alertService.warning('', data.resultado);

      } else {
        this.cerrarModal();
        this.contraseniaForm.reset();
        this.alertService.error('', environment.MENSAJES.OCURRIO_PROBLEMA.DESCRIPCION);
      }
      this.disabledRecuperarContrasenia = false;
    }, (error => {
      this.disabledRecuperarContrasenia = false;
      this.cerrarModal();
      this.contraseniaForm.reset();
      this.alertService.error('', environment.MENSAJES.OCURRIO_PROBLEMA.DESCRIPCION)

    }))
  }

  olvidoContrasenia(template: TemplateRef<any>) {

    this.modalRecuperar = this.modalService.show(template, { class: 'modal-correo', backdrop: 'static' });

  }

  mostrarModalCuenta(template: TemplateRef<any>) {
    this.modalCuenta = this.modalService.show(template, { class: 'modal-correo', backdrop: 'static' });
  }

  cerrarModalCuenta() {
    this.modalCuenta.hide();
  }
}

